import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {useContext} from 'react';
import Dashboard from './dashboard.js';

const Home = () =>{

  return(
    <Dashboard/>
  )



  return(
    <React.Fragment>
  <Container fixed>
 <Typography>Ana sayfa</Typography>
  </Container>
  </React.Fragment>
  )
}



export default Home;
